import { render, staticRenderFns } from "./VaimoSlider.vue?vue&type=template&id=45182b6e&scoped=true&"
import script from "./VaimoSlider.vue?vue&type=script&lang=js&"
export * from "./VaimoSlider.vue?vue&type=script&lang=js&"
import style0 from "./VaimoSlider.vue?vue&type=style&index=0&id=45182b6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45182b6e",
  null
  
)

export default component.exports